export default __webpack_public_path__ + "static/media/hacker.8024dda8.svg";